import { Controller } from "@hotwired/stimulus"

// Filters already-rendered people cards by name as you type.
// ponytail: client-side, all users are in the DOM. Switch to server search if the list outgrows one page.
export default class extends Controller {
  static targets = ["item", "empty"]

  filter(event) {
    const q = event.target.value.trim().toLowerCase()
    let any = false
    this.itemTargets.forEach((el) => {
      const match = el.dataset.name.includes(q)
      el.hidden = !match
      if (match) any = true
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = any
  }
}
